import React from "react";
import "../styles/gallery.css";

import g1 from "../assets/images/shop1.jpeg";
import g2 from "../assets/images/shop2.jpeg";
import g3 from "../assets/images/shop3.jpeg";
import g4 from "../assets/images/shop4.jpeg";
import g5 from "../assets/images/shop7.jpeg";
import g6 from "../assets/images/shop5.jpeg";
import g7 from "../assets/images/shop6.jpeg";
import g8 from "../assets/images/shopbg.jpeg";

const galleryImages = [
  {
    image: g1,
    category: "Testing Room",
  },
  {
    image: g2,
    category: "Testing Room",
  },
  {
    image: g3,
    category: "Waiting Area",
  },
  {
    image: g4,
    category: "Reception",
  },
  {
    image: g5,
    category: "Consultation Room 1",
  },
  {
    image: g6,
    category: "Consultation Room 2",
  },
  {
    image: g7,
    category: "Consultation Room 2",
  },
  {
    image: g8,
    category: "Entrance",
    position: "right",
  },
];

const Gallery = () => {
  return (
    <section className="gallery-section">
      <div className="gallery-header">
        <h2>Our Gallery</h2>
        <div className="line"></div>

        <p>
          Explore our clinic, advanced hearing care facilities, modern
          diagnostic equipment, and happy moments with our patients.
        </p>
      </div>

      <div className="gallery-filter">
        <button className="active">All</button>
        {/* <button>Clinic</button>
        <button>Products</button>
        <button>Testing</button>
        <button>Care</button> */}
      </div>

      <div className="gallery-grid" data-aos="fade-down">
        {galleryImages.map((item, index) => (
          <div className="gallery-card" key={index}>
            <img
              src={item.image}
              alt={item.title}
              style={{
                objectPosition: item.position || "center center",
              }}
            />

            <div className="gallery-overlay">
              <span>{item.category}</span>
              <h4>{item.title}</h4>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Gallery;